import HNSColors from "../../../../ui library/HNSColors";

export default function FeeSchedulePieTooltip({ item }) {
  if (!item || item.name === "No Data") {
    return null;
  }

  const formattedPercent = `${Number(item.value || 0).toFixed(2)}%`;

  return (
    <div
      className="rounded-[10px] px-3 py-2 shadow-sm"
      style={{
        backgroundColor: HNSColors.tertiary[900],
        border: `1px solid ${HNSColors.tertiary[700]}`,
      }}
    >
      <div className="text-[11px] font-medium" style={{ color: HNSColors.neutrals[300] }}>
        {item.name}
      </div>
      <div className="text-[13px] font-bold" style={{ color: HNSColors.primary[500] }}>
        {formattedPercent}
      </div>
    </div>
  );
}
